export const isEmpty = (value: any) => {
  return value === '' || value === null || value === undefined;
};
